import { is } from '@didi/webx-js'
/**
 * partition_id: 优惠商城、抖音商城、企业商城
 * xenv
 * product_type
 *
 * product_conf下配置业务线的项目，其中0表示通用配置，当业务线下没有配置时，使用通用配置； 业务线有配置时优先级最高
 */
const LOCAL_DEFAULT_APOLLO = {
  // 业务线差异化配置
  product_conf: {
    0: {
      // 字段含义：该业务下不允许跳打车toast文案, 当为空或不存在表示不限制，否则点击去打车时弹出此toast
      // 应用场景：例如在租车小程序下，除租车业务线外产品，在点击去打车时直接toast提示
      // 优先级比dache_btn_link低，原因： 有些位置配置的可能是个其他路径，因此， 每个位置的dache_btn_link 优先级最高
      dache_btn_show_toast: {
        'zh-CN': '',
        'en-US': '',
        'zh-HK': '',
      },
      // 首页
      index: {
        select_city_ignore_login: false,
      },
      // 确认订单页面
      order_confirm: {
        // 确认订单页面开关
        confirm_switch: false,
      },
      // 支付结果页去打车按钮配置
      pay_result: {
        // 打车按钮跳转链接
        dache_btn_link: 'onetravel://dache_anycar/entrance',
        // 按钮文案，区分中英港
        dache_btn_text: {
          'zh-CN': '立即去打车',
          'en-US': 'Get a Ride Now',
          'zh-HK': '立即叫車',
        },
      },
      // 订单详情页面
      order_detail: {
        // 头部券有剩余张数时的描述文案
        header_coupon_left_desc: {
          'zh-CN': '张打车券待使用',
          'en-US': 'coupon(s) available',
          'zh-HK': '張叫車優惠券待使用',
        },
        dache_btn_link: '',
        dache_btn_text: {
          'zh-CN': '立即去打车',
          'en-US': 'Get a Ride Now',
          'zh-HK': '立即叫車',
        },
        // 继续支付按钮展示
        continue_pay_btn_show: false,
        // 继续支付按钮隐藏后的提示文案,仅当continue_pay_btn_show 为false 时生效
        continue_pay_btn_hide_tip: {
          'zh-CN': '',
          'en-US': '',
          'zh-HK': '',
        },
      },
      // 订单列表页面
      order_list: {
        // 页面背景图
        header_img:
          'https://ut-static.udache.com/webx/fe-agility-wyc/oxbIHGiFUtM5acxNxQMgC.png',
        // 打车按钮跳转链接
        dache_btn_link: 'onetravel://dache_anycar/entrance',
        // 按钮文案，区分中英港
        dache_btn_text: {
          'zh-CN': '用券去打车',
          'en-US': 'Take a Ride',
          'zh-HK': '去Call車',
        },
      },
      // 商品点击配置
      goods_click: {
        // 点击跳转到第三方页面时，弹出toast提示
        // 第三方页面的判定： 下发了goods.link_url 或者 goods.credit_info?.status === 1（信贷商品在详情页0元购）
        jump_third_goods_page_toast: {
          'zh-CN': '',
          'en-US': '',
          'zh-HK': '',
        },
        // 点击跳转到第三方页面时，跳转到中间页的id, 此优先级低于jump_third_goods_page_toast
        jump_third_page_to_activity_id: '',
      },
      // 售后帮助页面配置
      help: {
        // 隐藏客服电话标志位
        hide_telephone: false,
        // 客户电话
        telephone: '400-000-0999',
      },

      // 退款页面配置
      refund: {
        telephone: '400-000-0999',
        // 退款结果提示文案，例如：如有问题可前往"首页-咨询"中联系在线客服
        result_warning_tips: '',
        // 我的原因选项
        own_refund_reason: {
          'zh-CN': [],
          'en-US': [],
          'zh-HK': [],
        },
        // 商家原因选项
        merchant_refund_reason: {
          'zh-CN': [],
          'en-US': [],
          'zh-HK': [],
        },
      },
    },
    // 顺风车
    259: {
      goods_detail: {
        hide_see_more_btn: true,
      },
      order_list: {
        dache_btn_link: '',
        dache_btn_text: {
          'zh-CN': '用券去打车',
          'en-US': 'Take a Ride',
          'zh-HK': '去Call車',
        },
      },
      pay_result: {
        dache_btn_link: '',
        dache_btn_text: {
          'zh-CN': '立即去打车',
          'en-US': 'Get a Ride Now',
          'zh-HK': '立即叫車',
        },
      },
    },
    // 代驾业务线
    261: {
      // 订单详情页面
      order_detail: {
        dache_btn_link:
          'OneTravel://driverservice/entrance?djact=c3001&djcl=7008',
        dache_btn_text: {
          'zh-CN': '立即叫代驾',
          'en-US': '立即叫代驾',
          'zh-HK': '立即叫代驾',
        },
      },
      // 订单列表页面
      order_list: {
        // 打车按钮跳转链接
        dache_btn_link:
          'OneTravel://driverservice/entrance?djact=c3001&djcl=7008',
        // 按钮文案，区分中英港
        dache_btn_text: {
          'zh-CN': '立即叫代驾',
          'en-US': '立即叫代驾',
          'zh-HK': '立即叫代驾',
        },
      },
      // 支付结果页去打车按钮配置
      pay_result: {
        // 打车按钮跳转链接
        dache_btn_link:
          'OneTravel://driverservice/entrance?djact=c3001&djcl=7008',
        // 按钮文案，区分中英港
        dache_btn_text: {
          'zh-CN': '立即叫代驾',
          'en-US': '立即叫代驾',
          'zh-HK': '立即叫代驾',
        },
      },
    },
    // 业务线下特殊配置，页面级别生效覆盖默认配置
    // 租车业务线
    271: {
      // 订单详情页面
      order_detail: {
        // 头部券有剩余张数时的描述文案
        header_coupon_left_desc: {
          'zh-CN': '张租车券待使用',
          'en-US': '张租车券待使用',
          'zh-HK': '张租车券待使用',
        },
        dache_btn_link: 'https://v.didi.cn/zb1nQMl',
        dache_btn_text: {
          'zh-CN': '立即去租车',
          'en-US': '立即去租车',
          'zh-HK': '立即去租车',
        },
        // 继续支付按钮展示
        continue_pay_btn_show: true,
        // 继续支付按钮隐藏后的提示文案,仅当continue_pay_btn_show 为false 时生效
        continue_pay_btn_hide_tip: {
          'zh-CN': '',
          'en-US': '',
          'zh-HK': '',
        },
      },
      // 支付结果页去打车按钮配置
      pay_result: {
        // 打车按钮跳转链接
        dache_btn_link: 'https://v.didi.cn/zb1nQMl',
        // 按钮文案，区分中英港
        dache_btn_text: {
          'zh-CN': '用券去租车',
          'en-US': '用券去租车',
          'zh-HK': '用券去租车',
        },
      },
      // 订单列表页面
      order_list: {
        // 打车按钮跳转链接
        dache_btn_link: 'https://v.didi.cn/zb1nQMl',
        // 按钮文案，区分中英港
        dache_btn_text: {
          'zh-CN': '用券去租车',
          'en-US': '用券去租车',
          'zh-HK': '用券去租车',
        },
      },
    },
    // 洗车业务线
    492: {
      // 订单详情页面
      order_detail: {
        // 头部券有剩余张数时的描述文案
        header_coupon_left_desc: {
          'zh-CN': '张洗车券待使用',
          'en-US': '张洗车券待使用',
          'zh-HK': '张洗车券待使用',
        },
        dache_btn_link: 'https://v.didi.cn/DgqKv0K',
        dache_btn_text: {
          'zh-CN': '立即去洗车',
          'en-US': '立即去洗车',
          'zh-HK': '立即去洗车',
        },
      },
      // 订单列表页面
      order_list: {
        // 打车按钮跳转链接
        dache_btn_link: 'https://v.didi.cn/p/vGkbJMk',
        // 按钮文案，区分中英港
        dache_btn_text: {
          'zh-CN': '用券去洗车',
          'en-US': '用券去洗车',
          'zh-HK': '用券去洗车',
        },
      },
      // 支付结果页去打车按钮配置
      pay_result: {
        // 打车按钮跳转链接
        dache_btn_link: 'https://v.didi.cn/p/vGkbJMk',
        // 按钮文案，区分中英港
        dache_btn_text: {
          'zh-CN': '用券去洗车',
          'en-US': '用券去洗车',
          'zh-HK': '用券去洗车',
        },
      },
    },
  },
  // 宿主端设置
  app: {
    // 打车路径
    dache_path: 'onetravel://dache_anycar/entrance',
    // 首页
    index_path: '',
    // 分享路径
    share_path: '/webx/entry/wyc',
    // appid
    appid: '',
    // 是否是小程序
    is_mini: false,
  },
  // 支付相关设置
  pay: {
    // 类型，支持三种： dweb、dfusion、dmp
    type: 'dmp',
    // 标准支付页面标志位，接入收银台的支付页面皆为标准支付页面
    is_standard_page: true,
    // 非标准支付的支付页面
    unstandard_pay_path: '',
    // 支付版本
    version: '',
    // 支付额外配置项
    options: {},
  },
}

const LOCAL_DEFAULT_APOLLO_MINI = {
  product_conf: {
    0: {
      dache_btn_show_toast: {
        'zh-CN': '',
        'en-US': '',
        'zh-HK': '',
      },
      index: {
        select_city_ignore_login: false,
      },
      order_confirm: {
        confirm_switch: false,
      },
      order_detail: {
        header_coupon_left_desc: {
          'zh-CN': '张打车券待使用',
          'en-US': 'coupon(s) available',
          'zh-HK': '張叫車優惠券待使用',
        },
        dache_btn_link: '/home/pages/dache',
        dache_btn_text: {
          'zh-CN': '立即去打车',
          'en-US': 'Get a Ride Now',
          'zh-HK': '立即叫車',
        },
        continue_pay_btn_show: true,
        continue_pay_btn_hide_tip: {
          'zh-CN': '',
          'en-US': '',
          'zh-HK': '',
        },
      },
      order_list: {
        header_img:
          'https://ut-static.udache.com/webx/fe-agility-wyc/oxbIHGiFUtM5acxNxQMgC.png',
        dache_btn_link: '/home/pages/dache',
        dache_btn_text: {
          'zh-CN': '用券去打车',
          'en-US': 'Take a Ride',
          'zh-HK': '去Call車',
        },
      },
      goods_click: {
        jump_third_goods_page_toast: {
          'zh-CN': '',
          'en-US': '',
          'zh-HK': '',
        },
        jump_third_page_to_activity_id: '',
      },
      help: {
        hide_telephone: false,
        telephone: '400-000-0999',
      },
      refund: {
        telephone: '400-000-0999',
        result_warning_tips: '',
        own_refund_reason: {
          'zh-CN': [],
          'en-US': [],
          'zh-HK': [],
        },
        merchant_refund_reason: {
          'zh-CN': [],
          'en-US': [],
          'zh-HK': [],
        },
      },
    },
    259: {
      goods_detail: {
        hide_see_more_btn: true,
      },
      order_list: {
        dache_btn_link: '',
        dache_btn_text: {
          'zh-CN': '用券去打车',
          'en-US': 'Take a Ride',
          'zh-HK': '去Call車',
        },
      },
      order_detail: {
        dache_btn_link: '',
        dache_btn_text: {
          'zh-CN': '立即去打车',
          'en-US': 'Get a Ride Now',
          'zh-HK': '立即叫車',
        },
      },
    },
    261: {
      order_detail: {
        dache_btn_link: '/pages/index/index?p=custom&dchn=P0dZQ66',
        dache_btn_text: {
          'zh-CN': '立即叫代驾',
          'en-US': '立即叫代驾',
          'zh-HK': '立即叫代驾',
        },
      },
      order_list: {
        dache_btn_link: '/pages/index/index?p=custom&dchn=P0dZQ66',
        dache_btn_text: {
          'zh-CN': '立即叫代驾',
          'en-US': '立即叫代驾',
          'zh-HK': '立即叫代驾',
        },
      },
    },
    271: {
      order_detail: {
        header_coupon_left_desc: {
          'zh-CN': '张租车券待使用',
          'en-US': '张租车券待使用',
          'zh-HK': '张租车券待使用',
        },
        dache_btn_link: 'https://v.didi.cn/p/n96qlRd',
        dache_btn_text: {
          'zh-CN': '立即去租车',
          'en-US': '立即去租车',
          'zh-HK': '立即去租车',
        },
        continue_pay_btn_show: false,
        continue_pay_btn_hide_tip: {
          'zh-CN': '',
          'en-US': '',
          'zh-HK': '',
        },
      },
      order_list: {
        dache_btn_link: 'https://v.didi.cn/p/n96qlRd',
        dache_btn_text: {
          'zh-CN': '用券去租车',
          'en-US': '用券去租车',
          'zh-HK': '用券去租车',
        },
      },
    },
    492: {
      order_detail: {
        header_coupon_left_desc: {
          'zh-CN': '张洗车券待使用',
          'en-US': '张洗车券待使用',
          'zh-HK': '张洗车券待使用',
        },
        dache_btn_link: 'https://v.didi.cn/DgqKv0K',
        dache_btn_text: {
          'zh-CN': '立即去洗车',
          'en-US': '立即去洗车',
          'zh-HK': '立即去洗车',
        },
      },
      order_list: {
        dache_btn_link: 'https://v.didi.cn/p/vGkbJMk',
        dache_btn_text: {
          'zh-CN': '用券去洗车',
          'en-US': '用券去洗车',
          'zh-HK': '用券去洗车',
        },
      },
    },
  },
  app: {
    dache_path: '/home/pages/dache',
    index_path: '/pages/home/index',
    share_path: '/webx/entry/wyc',
    appid: 'wxaf35009675aa0b2a',
    is_mini: true,
  },
  pay: {
    type: 'dmp',
    is_standard_page: true,
    unstandard_pay_path: '',
    version: '',
    options: {},
  },
}

export const getDefaultApollo = () => {
  return is('miniprogram,hwfastapp')
    ? LOCAL_DEFAULT_APOLLO_MINI
    : LOCAL_DEFAULT_APOLLO
}
// 后续跟随需求，逐渐将以下内容配置化
// TODO apollo toLaw 跳到规则页面
// TODO apollo getCardListData 省钱卡列表
// TODO apollo creditChannelId 信贷channelId
// TODO apollo getChannelType
// TODO apollo getAppId
// TODO apollo 订单详情页面隐藏去打车、充值手机号, isDy的相关处理
